<template>
    <el-popover :width="null">
        <template #reference>
            <slot name="reference" />
        </template>
        <slot />
    </el-popover>
</template>

<script>

export default {
    name: "BasePopover",
}
</script>

<style scoped>

</style>
